import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { setApiBase } from './api';
import './styles/widget.css';

Sentry.init({
  dsn: 'https://84055c8f600b7818d20a19753b3c5589@o61198.ingest.us.sentry.io/4511229587947520',
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
});

// Read API base from the script tag's data attribute, or default to same-origin
const scriptTag = document.querySelector('script[data-api]');
if (scriptTag) {
  setApiBase(scriptTag.getAttribute('data-api') || '');
}

const container = document.getElementById('hallochef-widget');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Došlo je do greške. Molimo osvježite stranicu.</p>}>
        <App />
      </Sentry.ErrorBoundary>
    </StrictMode>
  );
}
